<template>
    <v-overlay>
        <v-progress-circular indeterminate color="primary"/>
    </v-overlay>
</template>

<script>

import {AuthStatus} from "@/store/auth";
import DeployStore from "@/modules/mdeploy/database/DeployStore";
import PermissionsStore from "@/modules/mpermissions/database/PermissionsStore";
import AudienceTestStore from "@/modules/maudiences/database/AudienceTestStore";

export default {
    name: "Initialize",
    data: () => ({
        completed:0,
    }),
    computed: {
        authStatus() {
            return this.$store.getters["auth/getAuthStatus"];
        },
    },
    watch: {
        authStatus(value) {
            console.log("authStatus Listener: ", value)
            if (value === AuthStatus.AUTHORIZED) {
                this.fethApi()
            } else {
                console.log("router.push -> login")
                this.$router.push({name: "login"});
            }
        },
    },
    created() {
        console.log("Initialize created")
        // console.log("created: Initialize", this.authStatus)
        // if (this.authStatus === AuthStatus.AUTHORIZED) {
        //     this.fethApi()
        // }
    },
    methods:{
        checkForDone(){
            if (this.completed == 3){
                this.loading = false
                this.$router.push({name: "home"})
            }
        },
        fethApi() {
            console.log("fethApi -> ")
            this.$store.registerModule("deploy-store", DeployStore);
            this.$store.dispatch("deploy-store/init")
                .then(() => {
                    console.warn("Loaded successfully. deploy-store");
                    this.completed +=1;
                    this.checkForDone();
                }).catch((error) => {
                console.error("Error. deploy-store");
                this.$notify({title: 'deploy-store', text: error, type: "error"});
            })

            this.$store.registerModule("permissions-store", PermissionsStore);
            this.$store.dispatch("permissions-store/init")
                .then(() => {
                    console.warn("Loaded successfully. permissions-store");
                    this.completed +=1;
                    this.checkForDone();
                }).catch((error) => {
                console.error("Error. permissions-store");
                this.$notify({title: 'permissions-store', text: error, type: "error"});
            })

            this.$store.registerModule("audience-test-store", AudienceTestStore);
            this.$store.dispatch("audience-test-store/init")
                .then(() => {
                    console.warn("Loaded successfully. audience-test-store");
                    this.completed +=1;
                    this.checkForDone();
                }).catch((error) => {
                console.error("Error. audience-test-store");
                this.$notify({title: 'audience-test-store', text: error, type: "error"});
            })
        }
    }
}
</script>

<style scoped>

</style>